<template>
  <section class="color-new-light-grey">
    <v-container :class="{ 'pa-0': this.$vuetify.breakpoint.smAndDown }">
      <v-row>
        <v-col cols="12">
          <h1 class="text-h1 text-center">{{ $t('payments') }}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table :headers="headers"
                        :items="payments"
                        hide-default-footer
                        :mobile-breakpoint="0"
                        class="elevation-1 clickable"
                        :items-per-page="-1"
                        @click:row="navigateToDebt"
                        data-matomo-mask>
            <template #item.paymentDate="{ item }">
              {{ item.paymentDate | formatDate }}
            </template>
            <template #item.bookingDate="{ item }">
              {{ item.bookingDate | formatDate }}
            </template>
            <template #item.amount="{ item }">
              {{ item.amount | currency }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        payments: 'payments'
      }),
      headers () {
        return [
          { text: this.$t('debt'), value: 'debtNr' },
          { text: this.$t('paymentDate'), value: 'paymentDate' },
          { text: this.$t('registered'), value: 'bookingDate' },
          { text: this.$t('sum'), value: 'amount' }
        ]
      }
    },
    methods: {
      navigateToDebt (a) {
        this.$router.push('/debt/' + a.debtNr)
      }
    }
  }
</script>
